/**
 * Central GA4 analytics helper.
 *
 * All custom event tracking should go through `trackEvent()` so we have a
 * single, consistent surface to hook into / disable / extend.
 *
 * GA4 property: G-9C87YGXQ6B (configured in index.html).
 *
 * Recommended Key Events to mark in GA4 admin:
 *   - extension_click
 *   - chat_started
 *   - email_signup
 *   - pricing_cta_click
 */

export const EXTENSION_URL =
  "https://chromewebstore.google.com/detail/ai-sidebar-with-deepseek/inhcgfpbfdjbjogdfjbclgolkmhnooop";

type GtagFn = (...args: unknown[]) => void;

export type TrackedEventName =
  | "extension_click"
  | "chat_started"
  | "email_signup"
  | "pricing_cta_click"
  | "outbound_deepseek"
  | "blog_to_extension"
  | "newsletter_signup"
  | "cta_click";

export function trackEvent(
  name: TrackedEventName | string,
  params: Record<string, unknown> = {}
): void {
  try {
    const gtag = (window as unknown as { gtag?: GtagFn }).gtag;
    if (typeof gtag === "function") {
      gtag("event", name, {
        event_category: "engagement",
        ...params,
      });
    }
  } catch {
    // Never let analytics break UX
  }
}
